var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "ci-user-profile-qualifications ci-card ci-section ci-content-padding",
    },
    [
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: "flex-grow-1" }, [
          _c("h3", {
            staticClass: "h5 mb-0",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.users.profile.qualifications.title")
              ),
            },
          }),
        ]),
      ]),
      _vm.items && _vm.items.length > 0
        ? _vm._l(_vm.orderedList, function (item) {
            return _c(
              "div",
              {
                staticClass:
                  "ci-user-profile-qualifications__item py-3 border-bottom",
              },
              [
                _c("strong", {
                  staticClass: "text-sm d-block",
                  domProps: { textContent: _vm._s(item.name) },
                }),
                _c("span", {
                  staticClass: "text-sm d-block",
                  domProps: { textContent: _vm._s(item.issuing_organization) },
                }),
                _c("div", {
                  directives: [
                    {
                      name: "ci-format-date",
                      rawName: "v-ci-format-date",
                      value: {
                        value: item.issue_date,
                        opts: { year: "numeric", month: "long" },
                      },
                      expression:
                        "{ value: item.issue_date, opts: { year: 'numeric', month: 'long' } }",
                    },
                  ],
                  staticClass: "h6 my-1",
                }),
                item.credential_id
                  ? _c("small", {
                      domProps: { textContent: _vm._s(item.credential_id) },
                    })
                  : _vm._e(),
              ]
            )
          })
        : [
            _c("p", {
              domProps: {
                textContent: _vm._s(
                  _vm.$t(
                    "ui.components.users.profile.qualifications.empty_state"
                  )
                ),
              },
            }),
            _c(
              "div",
              { staticClass: "row flex-center" },
              [
                _c("ci-button", {
                  attrs: {
                    icon: "mdi-plus",
                    label: _vm.$t(
                      "ui.components.users.profile.qualifications.action"
                    ),
                    to: {
                      name: _vm.$routes.USERS_EDIT,
                      params: { id: _vm.slug },
                      hash: "#areaofqualifications",
                    },
                    variant: "outline-primary",
                  },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }